import { useState } from 'react';
import { useSelector } from 'react-redux';
import classNames from 'classnames';

import Button from 'atoms/button';
import { isEmpty } from 'util';

export default function SelectionScreen({
  defaultTips,
  toggleModal,
  onSelectTip,
  setScreen,
}) {
  const {
    summary,
    appointment,
    selectedTip: preSelectedTip,
  } = useSelector((state) => state.checkout);
  const subTotal = summary.subTotal || appointment.summary.subTotal;

  const [selectedTip, setSelectedTip] = useState(
    !isEmpty(preSelectedTip) ? preSelectedTip : defaultTips[1]
  );
  const onCustomTip = () => {
    setScreen('custom');
  };

  const onNoTip = () => {
    toggleModal(false);
  };

  const onConfirm = () => {
    onSelectTip(selectedTip);
    toggleModal(false);
  };

  return (
    <div className="prl-36 pb-30">
      <h2 className="f26">Add a tip</h2>
      <p className="c-grey">
        $
        {(subTotal.amount + (subTotal.amount * selectedTip.id) / 100).toFixed(
          2
        )}
      </p>
      <div className="flex-row w-100 justify-between">
        {defaultTips.map(({ value, id }, i) => (
          <button
            onClick={() => setSelectedTip({ value, id })}
            key={id}
            style={{ width: 116, height: 108 }}
            className={classNames(
              'radius-12 f28 text-center flex-row justify-center flex-column mt-25 mb-15 pointer',
              selectedTip.id === id
                ? 'border-primary-orange c-primary-orange b-light-orange'
                : 'border-light-purple c-black b-white',
              i === 1 && 'ml-5 mr-5'
            )}
          >
            <h4>{value}</h4>
            <p className="c-grey f13">
              ${((subTotal.amount * id) / 100).toFixed(2)}
            </p>
          </button>
        ))}
      </div>
      <Button
        shape="square"
        size="medium"
        className="w-100 mb-15 fw-400"
        variant="white-outlined"
        text="Custom tip"
        onClick={onCustomTip}
      />
      <Button
        shape="square"
        className="w-100 mb-15 fw-400"
        size="medium"
        variant="white-outlined"
        text="No tip"
        onClick={onNoTip}
      />
      <Button
        text="Confirm"
        size="large"
        className="w-100"
        onClick={onConfirm}
      />
    </div>
  );
}
